import { useRepositoryMutation } from '@mews-commander/data-access';
import { LocalizedText, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { downloadFile } from '@mews-commander/utils';

export const useDownloadExcelProcessing = () =>
    useRepositoryMutation('excelProcessing', 'download', {
        onSuccess: (data) => {
            downloadFile(data);
        },
    });

export const useUploadExcelProcessing = () =>
    useRepositoryMutation('excelProcessing', 'upload', {
        onSuccess: () => {
            showSuccessAlert({
                title: <LocalizedText textKey={TextKey.FileImportedSuccess} />,
            });
        },
    });
